import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useEffect, useState } from 'react'
import { consultarImpuestosPresentacion } from '../services/impuestos.service';
import { SUCCESS_GET_IMPUESTOS } from '../utilities/constants';
import { usePresentacionContext } from '../context/presentacion.context';
import { NumericFormat } from 'react-number-format';
import { formatMoney, formatMoneyCustom } from '../../shared/utilitties/formatMoney';

const ComprobantesDialogDetalleTableTasas = () => {
    
    const { presentacion } =  usePresentacionContext();
    const[dataImpuestos,setDataImpuestos] = useState([])
    const [totalGeneral,setTotalGeneral] = useState(0.0)
    const [spinnerImpuestos,setSpinnerImpuestos] = useState(true)

    useEffect(() => {
        (async () => {
            const {data,status} = await consultarImpuestosPresentacion(presentacion);
            if(status === 200){
              setDataImpuestos(data.impuestos)
              setTotalGeneral(data.totalGeneral)
              setSpinnerImpuestos(false)
            }
          })()
    }, [])

    if(dataImpuestos.length === 0) return <></>

    let detalleTasasList = dataImpuestos.map((item:any) => {
        return {
            servicioXBandera: item.servicioXBandera, 
            totalServicio: item.totalServicio,
        }
        })
    /*let totalTasas= {
        servicioXBandera: "Total", 
        totalServicio: totalGeneral,
      }
    //detalleTasasList.push(totalTasas)*/

        const formatMoneyBodyTemplate = (monto: any) => {
            return (
              <React.Fragment>
                <NumericFormat
                  value={monto}
                  displayType={"text"}
                  thousandSeparator={"."}
                  decimalSeparator={","}
                  prefix={"$"}
                  decimalScale={4}
                  fixedDecimalScale={true}
                />
              </React.Fragment>
            );
          };

    const renderFooter = () => { return (<span  style={{ display: "flex",justifyContent:"end",marginRight:"12px"  }}>Total ${formatMoneyCustom(totalGeneral,4)}</span>)};

    return (
          <DataTable
            value={detalleTasasList}
            responsiveLayout="stack"
            style={{border: "2px solid #0085ca"}}
            footer={renderFooter}
            size="small"
            scrollable scrollHeight="180px"
            loading={spinnerImpuestos}
          >
            <Column
              header="Servicio"
              field="servicioXBandera"
            />
            <Column
              header="Total"
              field="totalServicio"
              body={(rowData) => formatMoneyBodyTemplate(rowData.totalServicio)}
              style={{ justifyContent: "right" }}
              //bodyStyle={{textAlign: "right" }}
            ></Column>
          </DataTable>
  )
}

export default ComprobantesDialogDetalleTableTasas